import {
  buildResponse,
  callWorkflowGET_V4,
  callWorkflowPOST,
  callWorkflowPOST_V4,
  CTO_ENDPOINTS,
  Response,
  ResponsePostCto,
} from "@shape/reef-shared";
import type {
  AffectedAreaAccordionResponse,
  CreateStep2Body,
  CreateStep2MdbBody,
  CreateStep2RiskAssessmentComplementBody,
  RiskAssessmentDecisionBody,
} from "types";

export const postCreateStep2 = (
  vesselCode: string,
  ctoCode: string,
  body: CreateStep2Body,
  setObject: (obj: Response<ResponsePostCto>) => void
): void => {
  const response = callWorkflowPOST<ResponsePostCto, CreateStep2Body>(
    CTO_ENDPOINTS.VESSEL_CTO_EVALUATION(vesselCode, ctoCode),
    body
  );
  buildResponse<ResponsePostCto>(response, setObject);
};

export const postCreateNewStep2 = (
  vesselCode: string,
  ctoCode: string,
  body: CreateStep2Body,
  setObject: (obj: Response<ResponsePostCto>) => void
): void => {
  const response = callWorkflowPOST_V4<ResponsePostCto, CreateStep2Body>(
    CTO_ENDPOINTS.VESSEL_CTO_EVALUATION(vesselCode, ctoCode),
    body
  );
  buildResponse<ResponsePostCto>(response, setObject);
};

export const postCreateNewStep2Mdb = (
  vesselCode: string,
  ctoCode: string,
  body: CreateStep2MdbBody,
  setObject: (obj: Response<ResponsePostCto>) => void
): void => {
  const response = callWorkflowPOST_V4<ResponsePostCto, CreateStep2MdbBody>(
    CTO_ENDPOINTS.VESSEL_CTO_EVALUATION_MDB(vesselCode, ctoCode),
    body
  );
  buildResponse<ResponsePostCto>(response, setObject);
};

export const postCreateNewStep2RiskAssessmentComplement = (
  vesselCode: string,
  ctoCode: string,
  body: CreateStep2RiskAssessmentComplementBody,
  setObject: (obj: Response<ResponsePostCto>) => void
): void => {
  const response = callWorkflowPOST_V4<ResponsePostCto, CreateStep2RiskAssessmentComplementBody>(
    CTO_ENDPOINTS.VESSEL_CTO_EVALUATION_RISK_ASSESSMENT_COMPLEMENT(vesselCode, ctoCode),
    body
  );
  buildResponse<ResponsePostCto>(response, setObject);
};

export const getNewStep2AffectedAreas = (
  vesselCode: string,
  ctoCode: string,
  tagCode: string,
  mahCode: string
): Promise<AffectedAreaAccordionResponse> =>
  callWorkflowGET_V4<AffectedAreaAccordionResponse>(
    CTO_ENDPOINTS.VESSEL_CTO_EVALUATION_AFFECTED_AREAS(vesselCode, ctoCode),
    {
      params: {
        tag_code: tagCode,
        mah_code: mahCode,
      },
    }
  );

export const postCreateNewCtoDecision = (
  vesselCode: string,
  ctoCode: string,
  body: RiskAssessmentDecisionBody,
  setObject: (obj: Response<ResponsePostCto>) => void
): void => {
  const response = callWorkflowPOST_V4<ResponsePostCto, RiskAssessmentDecisionBody>(
    CTO_ENDPOINTS.VESSEL_CTO_DECISION(vesselCode, ctoCode),
    body
  );
  buildResponse<ResponsePostCto>(response, setObject);
};
